import React, { useState } from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import icSearch from '../assets/icons/ic_search.png';
import PropTypes from 'prop-types';

import { lightBlue } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: 236,
        height: 38,
        paddingLeft: '8px',
        paddingRight: '8px',
        border: 'solid 1px ' + lightBlue[100],
    },
    iconButton: {
        padding: 0,
        width: 18,
        height: 18
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        outline: 'none',
        border: 'none',
        fontFamily: "UniviaPro",
        fontSize: "12px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c"
    },
    formSearch: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        width: 236,
        height: 38,
        paddingLeft: '8px',
        paddingRight: '8px',
    }
}));

const FilterInput = ({ placeholder, getList }) => {
    const classes = useStyles();
    const [value, setValue] = useState('');

    const onChange = event => {
        setValue(event.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault()
        getList(value);
    }

    return (
        <form onSubmit={onSubmit} >
            <Paper elevation={0} className={classes.formSearch}>
                <img src={icSearch} className={classes.iconButton} alt='' />
                <input className={classes.input} placeholder={placeholder} onChange={onChange} value={value} />
            </Paper>
        </form>
    );
}

FilterInput.propTypes = {
    placeholder: PropTypes.string,
    getList: PropTypes.func.isRequired
};

export default FilterInput;
